<template>
    <div>

        <vue-headful title="OSHA E-File :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link to="/osha">
                        <i class="fa fa-folder-open"></i> OSHA
                    </router-link>
                </li>
                <li class="breadcrumb-item active"><i class="fa fa-hard-hat"></i> OSHA E-File</li>
            </ol>
        </h4>

        <div class="row">
            <div class="col-lg-8">
                <div class="card">
                    <div class="card-body">
                        <div v-if="loading" class="text-center">
                            <i class="fa fa-circle-o-notch fa-spin"></i> Calculating Your OSHA Numbers...
                        </div>
                        <div v-else>
                            <div class="alert alert-info">
                                EHS calculates all your OSHA numbers based on all logged Incidents for the previous year. You can manually override these numbers in the event that you have OSHA recoradable incidents that <strong>are not in EHS</strong>.
                            </div>

                            <div class="form-group row">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.total_hours_worked }">Total Hours Worked:</label>
                                <div class="col-lg-4 col-md-6 col-sm-8">

                                    <b-form-input v-model="data.total_hours_worked" type="text" placeholder="Enter Total Hours Worked" :class="{'is-invalid': errors.total_hours_worked}"></b-form-input>

                                    <span v-if="errors.total_hours_worked" class="text-danger">
                                        <span v-for="error in errors.total_hours_worked">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.total_deaths }">Total Deaths:</label>
                                <div class="col-lg-4 col-md-6 col-sm-8">

                                    <b-form-input v-model="data.total_deaths" type="text" placeholder="Enter Total Deaths" :class="{'is-invalid': errors.total_deaths}"></b-form-input>

                                    <span v-if="errors.total_deaths" class="text-danger">
                                        <span v-for="error in errors.total_deaths">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.total_dafw_cases }">Total DAFW Cases:</label>
                                <div class="col-lg-4 col-md-6 col-sm-8">

                                    <b-form-input v-model="data.total_dafw_cases" type="text" placeholder="Enter Total DAFW Cases" :class="{'is-invalid': errors.total_dafw_cases}"></b-form-input>

                                    <span v-if="errors.total_dafw_cases" class="text-danger">
                                        <span v-for="error in errors.total_dafw_cases">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.total_djtr_cases }">Total DJTR Cases:</label>
                                <div class="col-lg-4 col-md-6 col-sm-8">

                                    <b-form-input v-model="data.total_djtr_cases" type="text" placeholder="Enter Total DFTR Cases" :class="{'is-invalid': errors.total_djtr_cases}"></b-form-input>

                                    <span v-if="errors.total_djtr_cases" class="text-danger">
                                        <span v-for="error in errors.total_djtr_cases">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.total_other_cases }">Total Other Cases:</label>
                                <div class="col-lg-4 col-md-6 col-sm-8">

                                    <b-form-input v-model="data.total_other_cases" type="text" placeholder="Enter Total Hours Worked" :class="{'is-invalid': errors.total_other_cases}"></b-form-input>

                                    <span v-if="errors.total_other_cases" class="text-danger">
                                        <span v-for="error in errors.total_other_cases">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.total_dafw_days }">Total DAFW Days:</label>
                                <div class="col-lg-4 col-md-6 col-sm-8">

                                    <b-form-input v-model="data.total_dafw_days" type="text" placeholder="Enter Total DAFW Days" :class="{'is-invalid': errors.total_dafw_days}"></b-form-input>

                                    <span v-if="errors.total_dafw_days" class="text-danger">
                                        <span v-for="error in errors.total_dafw_days">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.total_djtr_days }">Total DJTR Days:</label>
                                <div class="col-lg-4 col-md-6 col-sm-8">

                                    <b-form-input v-model="data.total_djtr_days" type="text" placeholder="Enter Total DJTR Days" :class="{'is-invalid': errors.total_djtr_days}"></b-form-input>

                                    <span v-if="errors.total_djtr_days" class="text-danger">
                                        <span v-for="error in errors.total_djtr_days">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.total_injuries }">Total Injuries:</label>
                                <div class="col-lg-4 col-md-6 col-sm-8">

                                    <b-form-input v-model="data.total_injuries" type="text" placeholder="Enter Total Injuries" :class="{'is-invalid': errors.total_injuries}"></b-form-input>

                                    <span v-if="errors.total_injuries" class="text-danger">
                                        <span v-for="error in errors.total_injuries">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.total_skin_disorders }">Total Skin Disorders:</label>
                                <div class="col-lg-4 col-md-6 col-sm-8">

                                    <b-form-input v-model="data.total_skin_disorders" type="text" placeholder="Enter Total Skin Disorders" :class="{'is-invalid': errors.total_skin_disorders}"></b-form-input>

                                    <span v-if="errors.total_skin_disorders" class="text-danger">
                                        <span v-for="error in errors.total_skin_disorders">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.total_respiratory_conditions }">Total Respiratory Conditions:</label>
                                <div class="col-lg-4 col-md-6 col-sm-8">

                                    <b-form-input v-model="data.total_respiratory_conditions" type="text" placeholder="Enter Total Hours Worked" :class="{'is-invalid': errors.total_respiratory_conditions}"></b-form-input>

                                    <span v-if="errors.total_respiratory_conditions" class="text-danger">
                                        <span v-for="error in errors.total_respiratory_conditions">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.total_poisonings }">Total Poisonings:</label>
                                <div class="col-lg-4 col-md-6 col-sm-8">

                                    <b-form-input v-model="data.total_poisonings" type="text" placeholder="Enter Total Poisonings" :class="{'is-invalid': errors.total_poisonings}"></b-form-input>

                                    <span v-if="errors.total_poisonings" class="text-danger">
                                        <span v-for="error in errors.total_poisonings">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.total_hearing_loss }">Total Hearing Loss:</label>
                                <div class="col-lg-4 col-md-6 col-sm-8">

                                    <b-form-input v-model="data.total_hearing_loss" type="text" placeholder="Enter Total Hearing Loss" :class="{'is-invalid': errors.total_hearing_loss}"></b-form-input>

                                    <span v-if="errors.total_hearing_loss" class="text-danger">
                                        <span v-for="error in errors.total_hearing_loss">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.total_other_illnesses }">Total Other Illness:</label>
                                <div class="col-lg-4 col-md-6 col-sm-8">

                                    <b-form-input v-model="data.total_other_illnesses" type="text" placeholder="Enter Total Other Illness" :class="{'is-invalid': errors.total_other_illnesses}"></b-form-input>

                                    <span v-if="errors.total_other_illnesses" class="text-danger">
                                        <span v-for="error in errors.total_other_illnesses">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <hr/>

                            <b-button variant="success" v-on:click="return submitOsha()">Submit OSHA E-File</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                data: [],
                errors: {},
                loading: true,
            }
        },

        methods: {

            submitOsha(){
                //Alert the user that the feature is coming soon
                this.$toastr.success('OSHA E-File Submission is coming soon');
            },
        },

        mounted() {
            this.$http
                .get('osha/submit')
                .then(response => {
                    this.data = response.data;

                    //Set loading
                    this.loading = false;
                })
                .catch(response => {

                });
        }
    }
</script>
